import { BaseContainerModel } from '../../base-container.model';
import { bl_bi_report_query_template_hdr_RowClass } from '../../../dbschema/bl_bi_report_query_template_hdr.model';

export class QueriesTemplateHdrModel extends BaseContainerModel {
  bl_bi_report_query_template_hdr: bl_bi_report_query_template_hdr_RowClass = new bl_bi_report_query_template_hdr_RowClass();
}

export class RequestBodySql {
  sql: string;
}
